module.exports = __webpack_public_path__ + "img/1534045528.efb0064b.jpg";